import { IGetScheduledEventInviteesParams, IInvitees } from '@gem/models/scheduledEventModel';

import { scheduledEventModel } from 'APP/model/model';

export const getScheduledEventInvitees = async (
  params: IGetScheduledEventInviteesParams
): Promise<IInvitees | undefined> => {
  try {
    return await scheduledEventModel.getScheduledEventInvitees(params);
  } catch (error) {
    return;
  }
};
